<template>
    <div class="main-container">
        <om-loading
            v-if="isLoading && !loadingImgReady"
            :visable="isLoading && !loadingImgReady"
            type="whole"
            theme="blue"
        />
        <mui-errorloading
            v-else-if="isError"
            class="error"
            @handleRetry="initApplication"
        />
        <king-road-loading v-else-if="isComLoading" @jumpLoading="jumpLoading"/>
        <div
            v-else
            ref="wrapper"
            class="main-wrapper"
        >
            <!-- 顶部banner -->
            <section
                class="header"
                :style="{top: `${Number(safeBarHeight) + 8}px`}"
            >
                <div class="header-info">
                    <div v-debounce:[welfareType.coin]="handleJumpToWelfare" class="coin-num-bg">
                        <span class="coin-num">{{ myCoin }}</span>
                    </div>
                    <div class="stamina-num-bg">
                        <span class="stamina-num">{{ staminaNum }}/{{ staminaNumT }}</span>
                    </div>
                </div>
                <div v-debounce="handleJumpToWelfare" class="welfare-center">
                    <div class="medal-num">荣耀勋章x{{ medalNum }}</div>
                </div>
            </section>
            <!-- 更多玩儿法 -->
            <back-main
                v-if="isShowBackMain"
                :top="140"
            />
            <section
                v-if="levelList && levelList.length"
                ref="scrollRef"
                class="content"
            >
                <div class="road-start"></div>
                <level-item
                    v-for="(item,index) in levelList"
                    :ref="`level${index + 1}`"
                    :key="index"
                    :level-item="item"
                    :level-index="index"
                    :head-portrait="kingRoadData.headPortrait"
                    @judgePlatBury="judgePlatBury"
                />
                <div
                    v-if="isNewPeople"
                    v-debounce="startGame"
                    class="new-guide"
                ></div>
                <div class="road-end"></div>
            </section>
            <!--            <section class="footer"></section>-->
            <!-- 弹框 -->
            <dialog-box
                v-if="!isComLoading"
                v-show="isShowDialogBox"
                ref="dialog"
                :game-mode="defaultGameMode.kingRoad"
                :dialog-num="dialogNum"
                :dialog-data="dialogData"
                @jumpToGame="jumpToGame"
            />
        </div>
    </div>
</template>

<script>
import {mapActions, mapState, mapMutations} from 'vuex';
import {requestBdApi, getPlatInfo, goToLogin} from '@baidu/map-fe-utils';
import Const from '@/pages/pano-game/constant/Constant';
import {jumpByOpenapi} from '@/pages/pano-game/constant/JumpFunc';
import StatisticConst from '@/pages/pano-game/constant/StatisticConst';
import KingRoadLoading from '../Pano/components/Loading/KingRoadLoading';
import DialogBox from '../Main/components/Dialog/DialogBox.vue';
import LevelItem from './components/LevelItem';
import BackMain from '../../components/BackMain';
// import BScroll from 'better-scroll';

export default {
    data() {
        return {
            defaultGameMode: Const.gameMode,
            welfareType: Const.welfareType,
            isError: false,
            isLoading: true,
            // 过度动画loading
            isComLoading: false,
            loadingImgReady: true,
            dialogNum: 0,
            dialogData: {},
            isShowDialogBox: 0,
            defaultUserImg: '',
            jumpLevel: 1,
            scroll: null,
            // 是否展示更多玩儿法按钮
            isShowBackMain: false
        };
    },
    components: {
        KingRoadLoading,
        DialogBox,
        LevelItem,
        BackMain
    },
    computed: {
        ...mapState([
            'urlParams',
            'safeBarHeight',
            'eventKey',
            'isNative',
            'isLogin'
        ]),
        ...mapState('kingRoad', [
            'kingRoadData',
            'myCoin',
            'staminaNum',
            'staminaNumT',
            'kingRoadNum',
            'preShowNum',
            'medalNum',
            'isContinue',
            'isNewPeople',
            'breakLevel',
            'playMaxLevel',
            'levelList'
        ])
    },
    watch: {
        isComLoading(v) {
            if (!v) {
                this.$nextTick(() => {
                    !this.isLoading && this.initScroll();
                    this.$refs.dialog && this.$refs.dialog.stopScroll(false);
                });
            }
        }
    },
    mounted() {
        if (this.urlParams.pageType === 'kingRoad') {
            this.isShowBackMain = true;
        }
        this.initApplication();
        StatisticConst.kingRoadPageShow();
    },
    methods: {
        ...mapMutations([
            'setMyCoin'
        ]),
        ...mapActions([
            'getUrlParams',
            'getMainData'
        ]),
        ...mapActions('kingRoad', [
            'getKingRoadMain'
        ]),
        jumpLoading() {
            if (!this.isLoading) {
                this.isComLoading = false;
            }
        },
        // 初始化关卡位置
        initScroll() {
            if (!this.$refs.wrapper) {
                return false;
            }
            // this.scroll = new BScroll(this.$refs.wrapper);
            if (this.playMaxLevel < 5) {
                const scrollRef = this.$refs.scrollRef;
                this.$refs.wrapper.scrollTop = scrollRef.offsetHeight;
            }
            else if (this.playMaxLevel > this.kingRoadNum - 5) {
                return false;
            }
            else {
                const lastRef = this.$refs[`level${this.playMaxLevel}`][0].$el;
                this.$refs.wrapper.scrollTop = lastRef.offsetTop - this.$refs.wrapper.offsetHeight / 2;
            }
        },
        // 返回事件监听
        doCallback(cb) {
            requestBdApi('bdapi://backEvent?callback=backEvent');
            window.backEvent = () => {
                cb();
            };
        },
        // 初始化返回监听
        initBackEvent() {
            // 触发iOS返回webview事件
            if (getPlatInfo().isNative && getPlatInfo().isIos) {
                requestBdApi('bdapi://robackRefresh');
            }
            const that = this;
            // 监听客户端返回webview
            window.noticeBack = () => {
                that.getMainData();
                that.getKingRoadData();
            };
        },

        // 初始化大逃杀首页内容
        initApplication() {
            this.isLoading = true;
            this.isComLoading = true;
            this.getUrlParams();
            this.getMainData().then(() => {
                this.checkoutLogin();
            });
            this.getKingRoadData();
            this.initBackEvent();
        },
        /**
         * check登录状态，未登录进行登录
         */
        checkoutLogin() {
            if (!this.isLogin) {
                goToLogin('signinCallback');
            }
        },
        // 获取闯关首页数据
        getKingRoadData() {
            this.getKingRoadMain().then(resData => {
                this.isLoading = false;
                this.isError = false;
                if (resData) {
                    this.setMyCoin(resData.myCoin);
                }
                this.$nextTick(() => {
                    resData && this.initScroll();
                    this.$refs.dialog && this.$refs.dialog.stopScroll(false);
                });
            }).catch(err => {
                this.isLoading = false;
                this.isError = true;
            });
        },
        closeDialogBox() {
            this.isShowDialogBox = false;
            this.$refs.dialog.stopScroll(false);
        },
        openDialog(typeNum, level = 0) {
            this.dialogNum = typeNum;
            if (level) {
                this.jumpLevel = level;
                this.dialogData = {
                    jumpLevel: level,
                    levelType: this.levelList[level - 1].level_type
                };
            }
            this.isShowDialogBox = true;
            this.$refs.dialog.stopScroll(true);
            this.$refs.dialog.isShow = true;
        },
        // 跳转福利中心
        handleJumpToWelfare(welfareType = Const.welfareType.medal) {
            const url  = location.origin + location.pathname
                + `#/welfare?welfare=${welfareType}&fr=${this.urlParams.fr || ''}`;
            jumpByOpenapi(url);
            !this.isNative && this.judgePlatBury();
        },
        // 跳转指定关卡
        jumpToGame() {
            const url  = location.origin + location.pathname
                + `#/pano?type=${Const.gameMode.kingRoad}`
                + `&level=${this.jumpLevel}&fr=${this.urlParams.fr || ''}`;
            jumpByOpenapi(url);
        },
        // 调起闯关时的统计
        judgePlatBury() {
            if (this.isNative) {
                StatisticConst.playGame(Const.gameMode.kingRoad, this.jumpLevel);
                return;
            }
            if (this.shareCode) {
                StatisticConst.outNativeBackNative('duWord');
                return;
            }
            if (this.urlParams.fr === 'poster') {
                StatisticConst.outNativeBackNative('poster');
                return;
            }
            StatisticConst.outNativeBackNative('mainPage');
            return;
        },
        // 开始第一局游戏
        startGame() {
            this.$refs.level1 && this.$refs.level1[0] && this.$refs.level1[0].handleClickStartGame();
        }
    },
    destroyed() {
    }
};
</script>
<style src="./KingRoad.scss" lang="scss" scoped></style>
